<div class="container-fluid">
  <app-page-header
    icon="fe-alert-octagon"
    pretitle="GBT Admin"
    title="Casos críticos"
    description="Os casos críticos de gestão de carreira, em tempo real. Daqui abre-se uma ocorrência ligada ao caso."
  />
</div>

<div class="container-fluid">
  <!-- Colaboradores / Clientes -->
  <ul class="nav nav-tabs mb-4">
    <li class="nav-item">
      <a class="nav-link" [class.active]="tab() === 'colaboradores'" style="cursor: pointer;"
         (click)="selectTab('colaboradores')"><i class="fe fe-user me-1"></i> Colaboradores</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="tab() === 'clientes'" style="cursor: pointer;"
         (click)="selectTab('clientes')"><i class="fe fe-briefcase me-1"></i> Clientes</a>
    </li>
  </ul>

  <!-- Filtros -->
  <div class="card">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-12" [class.col-md-8]="!severities().length" [class.col-md-4]="severities().length">
          <label class="form-label small text-muted">Procurar</label>
          <input class="form-control" [(ngModel)]="q" (ngModelChange)="onSearch()"
                 [placeholder]="tab() === 'clientes' ? 'Nome do cliente' : 'Nome do colaborador'" />
        </div>
        <div class="col-12 col-md-4">
          <label class="form-label small text-muted">Estado</label>
          <select class="form-select" [ngModel]="status()" (ngModelChange)="onStatus($event)">
            <option [ngValue]="null">Todos</option>
            @for (o of statusOptions; track o.value) { <option [ngValue]="o.value">{{ o.label }}</option> }
          </select>
        </div>
        @if (severities().length) {
          <div class="col-12 col-md-4">
            <label class="form-label small text-muted">Gravidade</label>
            <select class="form-select" [ngModel]="severityId()" (ngModelChange)="onSeverity($event)">
              <option [ngValue]="null">Todas</option>
              @for (g of severities(); track g.id) { <option [ngValue]="g.id">{{ g.name }}</option> }
            </select>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body p-0">
      @if (error()) {
        <div class="text-center py-5 px-4">
          <span class="avatar avatar-lg mb-3">
            <span class="avatar-title fs-1 rounded-circle bg-danger-soft text-danger"><i class="fe fe-cloud-off"></i></span>
          </span>
          <p class="text-danger mb-0">{{ error() }}</p>
        </div>
      } @else if (loading()) {
        <p class="text-muted text-center py-5 mb-0">A carregar…</p>
      } @else if (total() === 0) {
        <div class="text-center py-6 px-4">
          <span class="avatar avatar-lg mb-3">
            <span class="avatar-title fs-1 rounded-circle bg-primary-soft text-primary"><i class="fe fe-alert-octagon"></i></span>
          </span>
          @if (filtered) {
            <h4 class="mb-1">Nenhum caso com esta busca</h4>
            <p class="text-muted small mb-3">Experimente outro nome ou limpe os filtros.</p>
            <button type="button" class="btn btn-sm btn-white" (click)="clearFilters()">Limpar filtros</button>
          } @else {
            <h4 class="mb-1">Sem casos críticos {{ tab() === 'clientes' ? 'de clientes' : 'de colaboradores' }}</h4>
            <p class="text-muted small mb-0">Quando houver casos no GBT Admin, aparecem aqui.</p>
          }
        </div>
      } @else {
        <div class="list-group list-group-flush">
          @for (c of items(); track c.id) {
            <a class="list-group-item list-group-item-action" [routerLink]="[c.id]">
              <div class="row align-items-center">
                <div class="col-auto">
                  <!-- Pessoa = círculo com iniciais; cliente/empresa = quadrado -->
                  <span class="avatar avatar-sm">
                    @if (c.targetType === 'CLIENT') {
                      <span class="avatar-title rounded bg-info-soft text-info"><i class="fe fe-briefcase"></i></span>
                    } @else {
                      <span class="avatar-title rounded-circle client-avatar">{{ initials(c.targetName) }}</span>
                    }
                  </span>
                </div>
                <div class="col ms-n2 min-w-0">
                  <h4 class="mb-1 text-truncate">{{ c.targetName }} <span class="text-muted fw-normal small">#{{ c.id }}</span></h4>
                  <p class="card-text small text-muted mb-0 text-truncate">
                    <i class="fe fe-calendar me-1"></i>Reportado em {{ c.reportDate | date: 'dd/MM/yyyy' }}
                    @if (c.nextFollowUp) {
                      <span class="mx-2">·</span><i class="fe fe-clock me-1"></i>Próximo acompanhamento {{ c.nextFollowUp | date: 'dd/MM/yyyy' }}
                    }
                  </p>
                </div>
                <div class="col-12 col-md-auto d-flex gap-2 mt-2 mt-md-0 ps-6 ps-md-3">
                  <span class="badge" [class]="severityBadge(c.severityLevel)">{{ c.severityName }}</span>
                  <span class="badge" [class]="statusBadge(c.statusCategory)">{{ c.statusName }}</span>
                </div>
              </div>
            </a>
          }
        </div>
      }
    </div>
    @if (total() > pageSize) {
      <app-pagination [total]="total()" [page]="page()" [pageSize]="pageSize" (pageChange)="onPage($event)" />
    }
  </div>
</div>
